import React from 'react';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { faArrowAltCircleRight, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//utils
import {hasText, isEmail, isCPF} from './../../../utils/utils';

//services
import serviceUsuarios from './../../../services/usuarios';

//redux
import { actions as actionsSite } from './../../../redux/actions/site';
import { actions as actionsAuth } from './../../../redux/actions/auth';
import { login } from '../../../services/auth';

const PreCadastro = () => {
    const dispatch = useDispatch();
    const { register, handleSubmit, errors, getValues } = useForm();

    const enviar = async data => {
        dispatch(actionsSite.setLoadingMsg("Enviando dados..."));
        const res = await serviceUsuarios.preCadastro(data);
        dispatch(actionsSite.setLoadingMsg(res.msg));
        setTimeout(() => {
            dispatch(actionsSite.setLoadingMsg(""));
        }, 3000);
        if (!res.erro) {
            await login(data);
            await dispatch(actionsAuth.setProfileByToken());
            // await serviceUsuarios.reenviarCodigo();
        }
    }

    return (
        <div className="form">
                <form className="formModule branco" onSubmit={handleSubmit(enviar)}>
                    <h3 className="tituloEtapa">1ª Etapa - Dados de acesso</h3>
                    <div className={errors.nome ? "field error" : "field"}>
                        <input name="nome" id="nome" onKeyUp={(e) => hasText(e)} type="text" ref={register({ required: true })} />
                        <label htmlFor="nome">Nome Completo</label>
                    </div>
                    <div className="break"></div>
                    <div className={errors.email ? "field error" : "field"}>
                        <input name="email" id="email" onKeyUp={(e) => hasText(e)} type="text" ref={register({ required: true, validate: { isEmail: value => isEmail(value) } })} />
                        <label htmlFor="email">E-mail</label>
                    </div>
                    <div className="break"></div>
                    <div className={errors.cpf ? "field error" : "field"}>
                        <input name="cpf" id="cpf" onKeyUp={(e) => hasText(e)} type="text" ref={register({ required: true, validate: { isCPF: value => isCPF(value),isNumeric: value => !isNaN(value) } })} />
                        <label htmlFor="cpf">CPF</label>
                    </div>
                    <div className={errors.ddd ? "field ddd error" : "field ddd"}>
                        <input name="ddd" id="ddd" maxLength={2} onKeyUp={(e) => { hasText(e) }} type="text" ref={register({ required: true, validate: { isNumeric: value => !isNaN(value) } })} />
                        <label htmlFor="ddd">DDD</label>
                    </div>
                    <div className={errors.celular ? "field error" : "field"}>
                        <input name="celular" id="celular" maxLength={9} onKeyUp={(e) => { hasText(e) }} type="text" ref={register({ required: true, validate: { isNumeric: value => !isNaN(value) } })} />
                        <label htmlFor="celular">Nº Celular</label>
                    </div>
                    <div className="break"></div>
                    <div className={errors.senha ? "field error" : "field"}>
                        <input name="senha" id="senha" onKeyUp={(e) => hasText(e)} type="password" ref={register({ required: true, minLength: 6 })} />
                        <label htmlFor="senha">Crie uma senha</label>
                    </div>
                    <div className={errors.confSenha ? "field error" : "field"}>
                        <input name="confSenha" id="confSenha" onKeyUp={(e) => hasText(e)} type="password" ref={register({ required: true, validate: value => value === getValues("senha") })} />
                        <label htmlFor="confSenha">Confirme a senha</label>
                    </div>
                    <div className="break"></div>
                    <div className="acoes">
                        <button type="submit" className="salvar"><FontAwesomeIcon icon={faArrowAltCircleRight} /> Enviar cadastro</button>
                        {/* <button type="button" className="cancelar" onClick={() => history.push('/painel/catalogos')}><FontAwesomeIcon icon={faBan} /> Cancelar</button> */}
                    </div>
                </form>

                {errors && Object.keys(errors).length > 0 &&
                    <div className="erros">

                        {errors.nome?.type === 'required' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo Nome</div>}
                        {errors.email?.type === 'required' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo E-mail</div>}
                        {errors.email?.type === 'isEmail' && <div><FontAwesomeIcon icon={faTimes} /> Preencha um E-mail válido</div>}
                        {errors.ddd?.type === 'required' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo DDD</div>}
                        {errors.ddd?.type === 'isNumeric' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo DDD com apenas números</div>}
                        {errors.celular?.type === 'required' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo Celular</div>}
                        {errors.celular?.type === 'isNumeric' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo Celular com apenas números</div>}
                        {errors.cpf?.type === 'required' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo CPF</div>}
                        {errors.cpf?.type === 'isCPF' && <div><FontAwesomeIcon icon={faTimes} /> Preencha um CPF válido</div>}
                        {errors.cpf?.type === 'isNumeric' && <div><FontAwesomeIcon icon={faTimes} /> Preencha um CPF apenas com números</div>}
                        {errors.senha?.type === 'required' && <div><FontAwesomeIcon icon={faTimes} /> Preencha uma senha</div>}
                        {errors.senha?.type === 'minLength' && <div><FontAwesomeIcon icon={faTimes} /> A senha precisa ter pelo menos 6 caracteres</div>}
                        {errors.confSenha?.type === 'required' && <div><FontAwesomeIcon icon={faTimes} /> Preencha a senha novamente</div>}
                        {errors.confSenha?.type === 'validate' && <div><FontAwesomeIcon icon={faTimes} /> As senhas não estão iguais</div>}

                    </div>
                }
            </div>
    );
};

export default PreCadastro;